module.exports = __webpack_public_path__ + "9cd4486ed28afb3f53248d8b539850ba.svg";